import React, { useContext,useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from 'react-bootstrap/AccordionContext';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleDown } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const SectionBackground = styled.div`
  background-color : ${props => props.theme.colors.white};
  color : ${props => props.theme.colors.gray_dark};
  padding-bottom:50px;
`

const CardBody = styled(Card.Body)`
  font: 20px/22px Roboto;
`

const AccordionSubtitle = styled.div`
  font: 28px/32px Abril Fatface;
  color : ${props => props.theme.colors.gray_dark};
`

const AccordionTitleContent = styled.div`
  font: 20px/22px Roboto;
  margin-top: 10px;
  margin-bottom: 20px;
`

const CardAccordion = styled(Card)`
  border: 2px solid ${props => props.theme.colors.gray_border};
  border-left:none;
  border-right:none;
  .card-header {
    padding:0;
    background-color: ${props => props.theme.colors.white};
    border-bottom:none;
  }
  .card-body {
    text-align: justify;
    padding-left:5px;
    padding-top:0;
    padding-bottom:15px;
    span {
      margin-left:15px;
    }
    div {
      margin-top:10px;
    }
  }
  .row-video {
    img {
      width:122px;
      height:70px;
      object-fit:contain;
    }
  }
  .col-video{
    @media(min-width:1200px) {
      padding-right:0;
    }
  }
`
const FAArrow = styled(FontAwesomeIcon)`
  font-size:1.5rem;
  color: ${props => props.theme.colors.primary_violet};
  &:hover, &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.colors.primary_violet_dark};
  }
`

const FACheck = styled(FontAwesomeIcon)`
  font-size:1rem;
  color: ${props => props.theme.colors.secondary_green10};
`

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <div
      css={css`
        font: Bold 20px/28px Roboto;
        outline:none;
        padding-top:30px;
        padding-bottom:30px};
        @media(max-width:767px){
          padding-top:15px;
          padding-bottom:15px};
        }
      `}
      onClick={decoratedOnClick}
      onKeyDown={decoratedOnClick}
      role="button"
      tabIndex={0}
    >
      <Row>
        <Col xs="10" md="11">
          {children}
        </Col>
        <Col xs="2" md="1" className="d-flex justify-content-end">
          <FAArrow icon={isCurrentEventKey ? faArrowAltCircleDown : faArrowAltCircleRight} />
        </Col>
      </Row>
    </div>
  );
}

export default function FaqSection2() {
  let activeKey = "0";

  if (typeof window !== `undefined`) {  
    let params = new URLSearchParams(document.location.search);
    let getactiveKey = params.get("defaultActiveKey");
    console.log("activekey:", activeKey);
    if (getactiveKey!==null){
      activeKey = getactiveKey;
    }
  }
useEffect(() => {
  if (typeof window !== `undefined`) {
  
  let params = new URLSearchParams(document.location.search);
  let getanchorid = params.get("id");
    
    if (getanchorid != null){
      let anchorid = getanchorid;
      console.log("anchorid:", anchorid);
      let ref = document.getElementById(anchorid);
      ref.scrollIntoView({
        behavior:'smooth',
        block:'center',
        inline:'center'
      });
      console.log("scrolling");
  }
}
});
  return (      
    <SectionBackground>
      <Container>
        <Row>
          <Col lg="12">
          <Accordion defaultActiveKey={activeKey}
          css={css`margin-bottom:25px;`}>
            {/* <AccordionTitle>What is mentorship?</AccordionTitle> */}
            <AccordionSubtitle>What is mentorship?</AccordionSubtitle>
            <AccordionTitleContent>Mentorship is a relationship where a person with experience and expertise (a ‘mentor’) passes their knowledge down to a more junior or less experienced person (a ‘mentee’). Mentorship is a two-way process: the mentee comes with a set of goals they want to consult in the session, and the mentor brings her knowledge and insights to help the mentee achieve them.</AccordionTitleContent>
            <CardAccordion id="section2-point1">
              <Card.Header>
                <ContextAwareToggle eventKey="0">1. What can I get out of a mentorship session?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <CardBody>
                <Col>
                    <Row>
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Consult your career plans, business idea, or any self-development plans; Gather insights on your dream company, job, or industry
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Get tips and tricks based on insider perspectives
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Get practical advice to help you solve your challenges
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Know what steps or resources you need to achieve your goals
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Connect with women professionals who understand your problem
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Find inspiration from our high-achieving mentors
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        and more!
                        </Col>
                    </Row>
                 </Col>
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section2-point2">
              <Card.Header>
                <ContextAwareToggle eventKey="1">2. How can a mentorship help me? What should I be expecting?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <CardBody>
                Mentorship allows you to get practical advice, insights, and perspectives from fellow women professionals who have gone through similar situations. Therefore, you can get a more realistic knowledge compared to what you get from reading books, doing online classes, etc.
                <br></br><br></br>
                The output expected from the sessions can vary from mentee to mentee. Some got insights on how to begin their first step, others got introduced to resources or people who can help them, etc. Therefore, mentees are highly encouraged to settle on their personal goals first before committing to a mentorship.
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section2-point3">
              <Card.Header>
                <ContextAwareToggle eventKey="2">3. What is discussed in a mentorship? Is there a set curriculum?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <CardBody>
                The curriculum depends on your specific needs, which is why we need your help in providing detailed answers on the documents provided for your session. In case you’re still unsure, we also have Themed Mentorship Packages, where we help set the goals for you (you can also ask about this if you book a pre-mentorship session with our founding team!).
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
          </Accordion>
          </Col>
        </Row>
      </Container>
    </SectionBackground>
  )
}